export default class WwindexchartService {
  getAll(period, country) {
    return fetch("https://api.tradersr.com/api/wwindexchart?period=" + period + "&country=" + country)
      .then(res => res.json());
  }
}